"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flexboxMixin = exports.alignSelfMixin = exports.flexWrapMixin = exports.flexDirectionMixin = exports.alignItemsMixin = exports.justifyContentMixin = exports.flexMixin = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _propTypes = require("../prop-types");

var flexMixinBase = function flexMixinBase(_ref) {
  var flex = _ref.flex;
  return (0, _utils.ifProp)(flex, "flex: ".concat(flex, ";"));
};

var flexMixin = (0, _stencilReactDesc.describe)(flexMixinBase).description('Adds a prop for CSS flex');
exports.flexMixin = flexMixin;
flexMixin.propTypes = {
  flex: (0, _propTypes.cssValue)().description("Sets the CSS 'flex' property for the element.")
};

var justifyContentMixinBase = function justifyContentMixinBase(_ref2) {
  var justifyContent = _ref2.justifyContent;
  return (0, _utils.ifProp)(justifyContent, "justify-content: ".concat(justifyContent, ";"));
};

var justifyContentMixin = (0, _stencilReactDesc.describe)(justifyContentMixinBase).description('Adds a prop for CSS justify-content.');
exports.justifyContentMixin = justifyContentMixin;
justifyContentMixin.propTypes = {
  justifyContent: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'justify-content' property for the element.")
};

var alignItemsMixinBase = function alignItemsMixinBase(_ref3) {
  var alignItems = _ref3.alignItems;
  return (0, _utils.ifProp)(alignItems, "align-items: ".concat(alignItems, ";"));
};

var alignItemsMixin = (0, _stencilReactDesc.describe)(alignItemsMixinBase).description('Adds a prop for CSS align-items.');
exports.alignItemsMixin = alignItemsMixin;
alignItemsMixin.propTypes = {
  alignItems: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'align-items' property for the element.")
};

var flexDirectionMixinBase = function flexDirectionMixinBase(_ref4) {
  var flexDirection = _ref4.flexDirection;
  return (0, _utils.ifProp)(flexDirection, "flex-direction: ".concat(flexDirection, ";"));
};

var flexDirectionMixin = (0, _stencilReactDesc.describe)(flexDirectionMixinBase).description('Adds a prop for CSS flex-direction.');
exports.flexDirectionMixin = flexDirectionMixin;
flexDirectionMixin.propTypes = {
  flexDirection: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-direction' property for the element.")
};

var flexWrapMixinBase = function flexWrapMixinBase(_ref5) {
  var flexWrap = _ref5.flexWrap;
  return (0, _utils.ifProp)(flexWrap, "flex-wrap: ".concat(flexWrap, ";"));
};

var flexWrapMixin = (0, _stencilReactDesc.describe)(flexWrapMixinBase).description('Adds a prop for CSS flex-wrap.');
exports.flexWrapMixin = flexWrapMixin;
flexWrapMixin.propTypes = {
  flexWrap: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-wrap' property for the element.")
};

var alignSelfMixinBase = function alignSelfMixinBase(_ref6) {
  var alignSelf = _ref6.alignSelf;
  return (0, _utils.ifProp)(alignSelf, "align-self: ".concat(alignSelf, ";"));
};

var alignSelfMixin = (0, _stencilReactDesc.describe)(alignSelfMixinBase).description('Adds a prop for CSS align-self.');
exports.alignSelfMixin = alignSelfMixin;
alignSelfMixin.propTypes = {
  alignSelf: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'align-self' property for the element.")
};
var flexboxMixin = (0, _utils.combineMixins)(flexMixin, justifyContentMixin, alignItemsMixin, flexDirectionMixin, flexWrapMixin, alignSelfMixin);
exports.flexboxMixin = flexboxMixin;